import { render } from "./EmailOnboardingDomain.vue?vue&type=template&id=54082fa7&scoped=true"
import script from "./EmailOnboardingDomain.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingDomain.vue?vue&type=script&lang=js"

import "./EmailOnboardingDomain.vue?vue&type=style&index=0&id=54082fa7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54082fa7"]])

export default __exports__